import React, { useEffect } from "react";
import { Col, Container, Row, FormGroup} from "react-bootstrap";
import { Input, Form} from 'antd';
import { AuthHeader, ImageElement, MainHeader } from "../../components";
import { Link } from "react-router-dom";

function Forgotpassword() {
    useEffect(() => {
        let navbar = document.querySelector(".header");
        let navbarHeight = navbar?.clientHeight;
        let authPage = document.querySelector(".authPage_inner");
        if(authPage){
        authPage.style.minHeight = `${window.innerHeight - navbarHeight}px`;
        }
    });
    return (
        <>
            <AuthHeader/>
            <main className="authPage">
                <div className="authPage_inner d-flex flex-column justify-content-center align-items-center">
                    <Container>
                        <Row className="g-0 align-items-center">
                            <Col xxl="6" lg="5" className="d-none d-lg-block">
                                <div className="authPage_left">
                                    <ImageElement source="auth-img.png" className="img-fluid"/>
                                </div>
                            </Col>
                            <Col xxl="6" lg="7">
                                <div className="authPage_right w-100 ms-auto">
                                    <div className="authPage_top w-100 mx-auto">
                                        <h1 className="authPage_top_title text-center">Forgot Password</h1>
                                        <p className="mb-0 text-center">Submit Email or Mobile Number to reset your password.</p>
                                        <div className="authPage_top_login">
                                            <Form>          
                                                <FormGroup className="form-group">
                                                    <label className="ant-label w-100">Mobile Number / Email</label>
                                                    <Input size="large" placeholder="Enter mobile number / email" />
                                                </FormGroup>
                                                <div className="authPage_top_forgt">
                                                    <Link to="/reset-password" className="btn-primary btn w-100 btn-lg">Submit</Link>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                    <div className="authPage_bottom text-center">
                                        Looks like you are a returning customer or we have added your information in the past. Let's reset your password.
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>
        </>
    );
  }
  
  export default Forgotpassword;